/* Roteamento do Portal do Responsável.

   Só duas rotas: a raiz (seleciona o aluno, ou entra direto se houver um só)
   e /aluno/:alunoId (o dashboard daquele aluno). Nada de sub-rotas por
   perfil como em Inteligência Educacional — aqui só existe um papel (8,
   Responsável), então não há perfil para escolher.

   O guard por papel ativo é defesa contra URL direta: sem o item de menu
   injetado (ver config/portalResponsavel.js), só se chega aqui digitando. */

import { CAlert, CSpinner } from "@coreui/react";
import { useSelector } from "react-redux";
import { Redirect, Route, Switch, useParams } from "react-router-dom";

import { PainelAluno } from "./components/PainelAluno";
import { SeletorAluno } from "./components/SeletorAluno";
import { useAsync } from "./lib/useAsync";
import { buscarAlunosVinculados } from "./lib/vinculos";
import { PORTAL_RESPONSAVEL_PATH } from "../../config/portalResponsavel";

export default function App() {
  const roleId = useSelector(state => state.general.active_roles?.role_id);

  if (roleId !== 8) {
    return (
      <CAlert color="warning">
        Este perfil não tem acesso ao Portal do Responsável. O painel abre
        conforme o papel com que você está no AVA.
      </CAlert>
    );
  }

  return <ComAcesso />;
}

function ComAcesso() {
  // O backend resolve os filhos pelo token (ver lib/vinculos.js) — não
  // precisa do id do responsável aqui.
  const alunos = useAsync(() => buscarAlunosVinculados(), []);

  if (alunos.loading) {
    return (
      <div className="d-flex justify-content-center py-5">
        <CSpinner color="primary" />
      </div>
    );
  }
  if (alunos.error) return <CAlert color="danger">{alunos.error}</CAlert>;
  if (alunos.data.length === 0) {
    return (
      <CAlert color="info">
        Nenhum aluno vinculado ao seu cadastro. Fale com a secretaria da escola
        se isso não for esperado.
      </CAlert>
    );
  }

  return (
    <Switch>
      <Route exact path={PORTAL_RESPONSAVEL_PATH}>
        {alunos.data.length === 1 ? (
          <Redirect
            to={`${PORTAL_RESPONSAVEL_PATH}/aluno/${alunos.data[0].id}`}
          />
        ) : (
          <SeletorAluno
            alunos={alunos.data}
            basePath={PORTAL_RESPONSAVEL_PATH}
          />
        )}
      </Route>

      <Route path={`${PORTAL_RESPONSAVEL_PATH}/aluno/:alunoId`}>
        <RotaAluno alunos={alunos.data} />
      </Route>

      <Redirect to={PORTAL_RESPONSAVEL_PATH} />
    </Switch>
  );
}

function RotaAluno({ alunos }) {
  const { alunoId } = useParams();
  const aluno = alunos.find(a => String(a.id) === alunoId);

  // Aluno na URL que não está entre os vinculados ao responsável logado —
  // nunca renderiza o painel dele. Isto é o que impede um responsável de
  // ver o filho de outro só editando o id na barra de endereço.
  if (!aluno) return <Redirect to={PORTAL_RESPONSAVEL_PATH} />;

  return <PainelAluno aluno={aluno} mostrarTrocarAluno={alunos.length > 1} />;
}
